// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_wrapper__AvkTk {
  display: grid;
  grid-template-columns: 0.5fr 1fr;
  gap: 32px;
  align-items: flex-start;
}

.profile_avatar__IrK39 {
  border-radius: 6px;
  max-width: 450px;
  width: 100%;
  min-width: 250px;
}

.profile_form__4JSRH {
  padding: 24px;
  border-radius: 6px;
  display: grid;
  gap: 24px;
}

.profile_form-content__4jxxm {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.profile_input__OOzWA {
  background-color: var(--primary-background-color);
}

.profile_actions__w3aHx {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .profile_wrapper__AvkTk {
    grid-template-columns: 1fr;
    align-items: center;
  }

  .profile_form__4JSRH {
    padding: 0;
  }

  .profile_avatar__IrK39 {
    max-width: 350px;
  }

  .profile_content__F5\\+Um {
    display: flex;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/params/profile.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF","sourcesContent":[".wrapper {\n  display: grid;\n  grid-template-columns: 0.5fr 1fr;\n  gap: 32px;\n  align-items: flex-start;\n}\n\n.avatar {\n  border-radius: 6px;\n  max-width: 450px;\n  width: 100%;\n  min-width: 250px;\n}\n\n.form {\n  padding: 24px;\n  border-radius: 6px;\n  display: grid;\n  gap: 24px;\n}\n\n.form-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.input {\n  background-color: var(--primary-background-color);\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n@media (max-width: 768px) {\n  .wrapper {\n    grid-template-columns: 1fr;\n    align-items: center;\n  }\n\n  .form {\n    padding: 0;\n  }\n\n  .avatar {\n    max-width: 350px;\n  }\n\n  .content {\n    display: flex;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `profile_wrapper__AvkTk`,
	"avatar": `profile_avatar__IrK39`,
	"form": `profile_form__4JSRH`,
	"form-content": `profile_form-content__4jxxm`,
	"input": `profile_input__OOzWA`,
	"actions": `profile_actions__w3aHx`,
	"content": `profile_content__F5+Um`
};
export default ___CSS_LOADER_EXPORT___;
